import React from "react";
import { Modal } from "reactstrap";
import { useTranslation } from "react-i18next";

const ShortfallWarningModal = ({
  isOpen,
  toggle,
  shortfallPoints,
  shortfallDollars,
  onEditCart,
  onPurchasePoints,
}) => {
  const { t } = useTranslation();

  return (
    <Modal className="cc-confirm-modal" isOpen={isOpen} toggle={toggle}>
      <div className="cc-confirm-modal__inner">
        <div className="cc-confirm-modal__header">
          <div className="cc-confirm-modal__header-icon" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div>
            <h3 className="cc-confirm-modal__title">
              {t("insufficient_balance_checkout_title")}
            </h3>
            <p className="cc-confirm-modal__subtitle">
              {t("insufficient_balance_checkout_subtitle")}
            </p>
          </div>
          <button
            type="button"
            className="cc-confirm-modal__close"
            onClick={toggle}
            aria-label="Close"
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path
                d="M1 1l12 12M13 1L1 13"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>

        <div className="cc-confirm-modal__body">
          <p className="cc-confirm-modal__note">
            {t("insufficient_balance_checkout_message")}
          </p>

          <div className="cc-confirm-modal__breakdown">
            <div className="cc-confirm-modal__row">
              <span>{t("points_shortfall")}</span>
              <span>{shortfallPoints?.toLocaleString()} pts</span>
            </div>
            <div className="cc-confirm-modal__row cc-confirm-modal__row--total">
              <span>{t("top_up_amount")}</span>
              <strong>${parseFloat(shortfallDollars || 0).toFixed(2)}</strong>
            </div>
          </div>
        </div>

        <div className="cc-confirm-modal__footer">
          <button
            type="button"
            className="cc-confirm-modal__btn cc-confirm-modal__btn--cancel"
            onClick={onEditCart}
          >
            {t("edit_cart")}
          </button>
          <button
            type="button"
            className="cc-confirm-modal__btn cc-confirm-modal__btn--confirm"
            onClick={onPurchasePoints}
          >
            {t("purchase_points")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ShortfallWarningModal;
